import { put, call } from 'redux-saga/effects';
import { getFarmEntitiesStateSuccess } from '../../reducers/farmDetailsSlice';
import withLoading from '../../sagas/loadingSaga';

export default function* entitiesStateSaga(api, action) {
  try {
    yield* withLoading(function* () {
      const { farmId } = action.payload;
      const entitiesStatusReq = yield call(api.getFarmEntitiesState, farmId);
      const entitiesStatuses = entitiesStatusReq.data;

      yield put(getFarmEntitiesStateSuccess(entitiesStatuses));
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to get farm entities state:', error);
  }
}
